import { render, staticRenderFns } from "./CompComment.vue?vue&type=template&id=2e259014&"
import script from "./CompComment.vue?vue&type=script&lang=js&"
export * from "./CompComment.vue?vue&type=script&lang=js&"
import style0 from "./CompComment.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports